(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Opzioni_ticket', Opzioni_ticket);

    Opzioni_ticket.$inject = ['$resource'];

    function Opzioni_ticket ($resource) {
        var resourceUrl =  'api/opzioni-tickets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
